import { render, staticRenderFns } from "./SerpLeadBanner.vue?vue&type=template&id=b1a8084c&scoped=true&"
import script from "./SerpLeadBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SerpLeadBanner.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SerpLeadBanner.vue?vue&type=style&index=0&id=b1a8084c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8084c",
  null
  
)

export default component.exports